import React from 'react';
import { Base } from 'lib/cortiUI';
import { QuestionLoader } from './QuestionLoader';
export const QuestionsListLoader = () => {
    const cardsArray = [0, 1, 2];
    return (React.createElement(Base, { display: "flex", "justify-content": "space-between", gap: 3, width: "100%" }, cardsArray.map((num) => (React.createElement(QuestionLoader, { key: num })))));
};
